const divForgotPassConfirm = {
text: 'Password changed successfully'
};

export default divForgotPassConfirm;
